import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
} from '@chakra-ui/react';

const CustomerChangeModal = ({ isOpen, onClose, confirmCustomerChange }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent maxW="400px" p={4}>
        <ModalHeader textAlign="center">Confirmación</ModalHeader>
        <ModalCloseButton />
        <ModalBody textAlign="center">
          ¿Desea cambiar el cliente actual para este vehículo?
        </ModalBody>
        <ModalFooter justifyContent="center">
          <Button variant="adminPrimary" onClick={confirmCustomerChange} mr={3}>
            Continuar
          </Button>
          <Button colorScheme="gray" onClick={onClose}>
            Cancelar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CustomerChangeModal;